module.exports = __webpack_public_path__ + "img/mic.b00066dc.jpg";